import enums from "../enums";

const websocket = (
	state = {
		feed: [],
		status: null,
		subscribedMatches: [],
		sessionEnded: false,
		otherIp: null,
	},
	action
) => {
	try {
		switch (action.type) {
			case enums.SESSION_ENDED: {
				return { ...state, sessionEnded: true, otherIp: action.msg.ip };
			}
			case enums.SESSION_RESET:
				return { ...state, sessionEnded: false, otherIp: null };
			case "WS_CONNECTED":
				return { ...state, status: action.status };
			default:
				return state;
		}
	} catch (err) {
		console.log("[WEBSOCKET ERR]: ", err.message);
		return { ...state };
	}
};

export default websocket;
